import axios from "axios"
const base = "/api/akademie/leadership/controlling"
const options = (extra = {}) => ({ ...extra, headers: { Authorization: localStorage.getItem("token") } })
const get = (path, params) => axios.get(`${base}${path}`, options({ params })).then(res => res.data)
const post = (path, data) => axios.post(`${base}${path}`, data, options()).then(res => res.data)
const put = (path, data) => axios.put(`${base}${path}`, data, options()).then(res => res.data)
const remove = (path, data) => axios.delete(`${base}${path}`, options({ data })).then(res => res.data)
export default {
  academyControl: {
    settings: () => get("/settings"),
    saveSettings: data => put("/settings", data),
    studioAudits: (studioId, page) => get("/audits/studio", { studioId, page }),
    audits: (studioId, page) => get("/audits", { studioId, page }),
    createAudit: data => post("/audits", data),
    updateAudit: (id, data) => put(`/audits/${id}`, data),
    deleteAudit: (id, revision) => remove(`/audits/${id}`, { revision }),
  },
}
